import { AxiosResponse } from 'axios';
import { apisiseci } from './api';
import { FilterObject } from '../Pages/CheckProcess';

const getProcessos = (filtro: FilterObject): Promise<AxiosResponse> => {
  const { param, value } = filtro;

  return apisiseci.get(`/cms/consulta-sicweb-publico/?${param}=${value}`);
};

export default getProcessos;
